<div class="modal fade" id="kt_modal_courier_company_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Courier Company' : 'Add Courier Company' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="courierCompanyForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Company Name -->
            <div class="col-12 mb-5">
              <label class="form-label required">Company Name</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="company_name"
                placeholder="Enter company name"
                [class.is-invalid]="company_name?.invalid && company_name?.touched"
              />
              <div *ngIf="company_name?.invalid && company_name?.touched" class="invalid-feedback">
                <div *ngIf="company_name?.errors?.['required']">Company name is required</div>
                <div *ngIf="company_name?.errors?.['minlength']">Company name must be at least 2 characters</div>
              </div>
            </div>

            <!-- Start URL -->
            <div class="col-12 mb-5">
              <label class="form-label required">Start URL</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="start_url"
                placeholder="Enter start URL"
                [class.is-invalid]="start_url?.invalid && start_url?.touched"
              />
              <div *ngIf="start_url?.invalid && start_url?.touched" class="invalid-feedback">
                <div *ngIf="start_url?.errors?.['required']">Start URL is required</div>
              </div>
            </div>

            <!-- End URL -->
            <div class="col-12 mb-5">
              <label class="form-label required">End URL</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="end_url"
                placeholder="Enter end URL"
                [class.is-invalid]="end_url?.invalid && end_url?.touched"
              />
              <div *ngIf="end_url?.invalid && end_url?.touched" class="invalid-feedback">
                <div *ngIf="end_url?.errors?.['required']">End URL is required</div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer p-3">
          <button type="button" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading"
          >
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            {{ isEditMode ? 'Update' : 'Add' }} Courier Company
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
